import { render, staticRenderFns } from "./RatesReadOnly.vue?vue&type=template&id=ea4ef36a&"
import script from "./RatesReadOnly.vue?vue&type=script&lang=js&"
export * from "./RatesReadOnly.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports